module.exports = __webpack_public_path__ + "img/Query-img.6cdc52cf.svg";